export default {
  Home: 'Casa',
  Mobile: 'Móvil',
  Work: 'Trabajo',
  Fax: 'Fax',
  Other: 'Otro',
  'Program TFN': 'Programa TFN',
  Business: 'Negocio',
  Primary: 'Primario'
};
